module.exports = "https://coursera_assets.s3.amazonaws.com/images/15aa43a6485a610e137ca07bf6390b1f.png";